/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable new-parens */
import './css/index.scss';
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { isDesktop, isMobile } from 'react-device-detect';

import { useContext } from 'react';

import { APP_SECTION } from './config/index';
import { AppContext } from './context/AppContext';
import { useAppConfig } from './hooks/useAppConfig';
import { useGeneralTools } from './hooks/useGeneralTools';

import SideNav from './components/SideNav';
import Comfort from './pages/Comfort';
import Energy from './pages/Energy';
import Devices from './pages/Devices';
import Trends from './pages/Trends';
import Solar from './pages/Solar';
import Scheduler from './pages/Scheduler';
import Settings from './pages/Settings';
import Resources from './pages/Resources';
import LobbyKiosk from './pages/LobbyKiosk';
import Loading from './components/Loading';
import Notifications from './pages/Notifications';

import {
  saveCampuses,
  setCurrentCampus,
  setCurrentBuilding,
  setCurrentZone,
  setCurrentGX,
  setCurrentGXData,
  setCurrentEVData,
  setCurrentBatteryData,
  setCurrentZoneData,
  updateCurrentCampusData,
  setUserData,
} from './actions';
import authentication from './utilities/Authentication';
import AuthenticatedComponent from './utilities/AuthenticatedComponent';
import configuration from './config';

const App = ({
  saveCampuses,
  setCurrentCampus,
  setCurrentBuilding,
  setCurrentZone,
  setCurrentGX,
  setCurrentGXData,
  setCurrentEVData,
  setCurrentBatteryData,
  setCurrentZoneData,
  updateCurrentCampusData,
  setUserData,
  currentCampusId,
  currentBuildingId,
  currentZoneId,
  currentZoneData,
  currentGXId,
  currentCampusData,
  currentGXData,
  currentEVData,
  currentBatteryData,
}) => {
  const authenticatedComponent = new AuthenticatedComponent();
  const hasSchedule = sessionStorage.scheduleId;
  const mobileScreenSize = window.innerWidth <= 500 || window.screen.width <= 500;
  const desktopScreenSize = window.innerWidth >= 1024 || window.screen.width >= 1024;

  let currentUrl = window.location.pathname;
  let pageParam = window.location.pathname.split('/')[1];
  let campusParam = window.location.pathname.split('/')[2];
  let buildingParam = window.location.pathname.split('/')[3];
  let zoneParam = window.location.pathname.split('/')[4];
  let gxParam = window.location.pathname.split('/')[3];

  const { appConfig, setAppConfig } = useContext(AppContext);
  const { campusHasZones } = useAppConfig();
  const { getUrlPathname, setHtmlPageTitle } = useGeneralTools();

  const [campuses, setCampuses] = useState([]);
  const [solarCampusData, setSolarCampusData] = useState([]);
  const [campusesLoaded, setCampusLoaded] = useState(false);
  const [hasPassthrough, setHasPassthrough] = useState(false);
  const [activePage, setActivePage] = useState('');
  const [showMobile, setShowMobile] = useState(false);
  const [currentWindowSize, setCurrentWindowSize] = useState(window.innerWidth);
  const [processing, setProcessing] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [showLoading, setShowLoading] = useState(false);
  const [selectedModal, setSelectedModal] = useState(null);
  const [currentScheduleId, setCurrentScheduleId] = useState(hasSchedule ? hasSchedule : null);
  const [hasSingleGX, setHasSingleGX] = useState(false);
  const [currentScheduleData, setCurrentScheduleData] = useState([]);
  const [showSolarIcon, setShowSolarIcon] = useState(false);

  const [userLoggedIn, setUserLoggedIn] = useState(authentication.isLoggedIn());
  const [isKiosk, setIsKiosk] = useState(currentUrl.includes('lobbyKiosk'));

  useEffect(() => {
    // console.log('appConfig', appConfig);
  }, [appConfig]);

  useEffect(() => {
    checkHasCampusZones();
  }, [currentCampusData]);

  useEffect(() => {
    updateCurrentMeta(currentCampusData);
  }, [currentCampusData, appConfig, activePage, currentUrl, currentZoneData]);

  useEffect(() => {
    setShowMobile((isMobile || mobileScreenSize) && !isDesktop && !desktopScreenSize);
    setActivePage(getUrlPathname().split('/')[1]);

    sessionStorage.removeItem('scheduleId');

    window.addEventListener('focus', validateAuthentication);
    window.addEventListener('resize', handleResize);
    window.addEventListener('popstate', onBackButtonEvent);

    return () => {
      window.removeEventListener('focus', validateAuthentication);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('popstate', onBackButtonEvent);
    };
  }, []);

  useEffect(() => {
    setUserLoggedIn(authentication.isLoggedIn());
    setIsKiosk(currentUrl.includes('lobbyKiosk'));
    checkForSolarData();
  }, [currentUrl]);

  useEffect(() => {
    if (userLoggedIn || !isKiosk) {
      authentication.handleAuthentication(postAuthentication);
    }
  }, [userLoggedIn]);

  useEffect(() => {
    if (campusesLoaded === true) {
      checkHasCampusZones();
      setPageData();
    }
  }, [campusesLoaded]);

  const validateAuthentication = () => {
    authentication.checkExpiration();
  };

  const onBackButtonEvent = (e) => {
    e.preventDefault();
    window.history.replaceState(null, '', window.location.pathname);
  };

  const handleResize = () => {
    const newShowMobile = (isMobile || mobileScreenSize) && !isDesktop && !desktopScreenSize;
    if (showMobile !== newShowMobile) {
      setShowMobile(newShowMobile);
    }
    setCurrentWindowSize(window.innerWidth);
  };

  const updateCampusCallback = (data) => {
    updateCurrentCampusData(data);
  };

  const updateGXCallback = (energyData) => {
    setHasSingleGX((prevState) => energyData.gridInterconnects.length <= 1);
    setCurrentGXData(energyData);

    if (energyData.gridInterconnects.length <= 1) {
      setCurrentGX(
        energyData.gridInterconnects[0].gridInterconnectDescription.gridInterconnectEntityKey
      );
    }

    if (pageParam === 'trends' && currentGXId === null) {
      setCurrentGX(
        energyData.gridInterconnects[0].gridInterconnectDescription.gridInterconnectEntityKey
      );
    }
  };

  const evCallback = (evData) => {
    setCurrentEVData(evData);
  };

  const batteryCallback = (batteryData) => {
    setCurrentBatteryData(batteryData);
  };

  const zoneSummaryCallback = (zoneData) => {
    if (!zoneData) {
      setCurrentZoneData(null);
      return;
    }
    setCurrentZoneData(zoneData);
    if (currentZoneId !== zoneData.thermalZoneEntityKey) {
      setCurrentZone(zoneData.thermalZoneEntityKey);
    }
  };

  const allScheduleCallback = (data) => {
    setCurrentScheduleData(data);
  };

  const checkHasCampusZones = () => {
    const hasZones = campusHasZones(currentCampusData);
    setAppConfig((prevConfig) => ({
      ...prevConfig,
      sections: {
        ...prevConfig.sections,
        comfort: {
          ...prevConfig.sections.comfort,
          hasZones: hasZones,
        },
      },
    }));
  };

  const updateCurrentMeta = (currentCampusData) => {
    const isEv = getUrlPathname().split('/')[3] === 'ev';
    const isSchedules = getUrlPathname().split('/')[3] === 'schedules';
    const isEvents = getUrlPathname().split('/')[3] === 'events';
    const isBattery = getUrlPathname().split('/')[3] === 'battery';

    let sectionName = null;
    let currentPageName = null;

    switch (pageParam) {
      case 'devices':
        sectionName = isEv
          ? APP_SECTION.EV.DISPLAY_NAME
          : isBattery
            ? APP_SECTION.BATTERY.DISPLAY_NAME
            : null;
        break;
      // TODO: Enabled when routing is updated
      // case 'scheduler':
      //   sectionName = isSchedules
      //     ? APP_SECTION.SCHEDULES.DISPLAY_NAME
      //     : isEvents
      //       ? APP_SECTION.EVENTS.DISPLAY_NAME
      //       : null;
      //   break;
      case 'comfort':
        sectionName = APP_SECTION.COMFORT.DISPLAY_NAME;

        if (currentZoneData?.shortThermalZoneDisplayName) {
          currentPageName = currentZoneData.shortThermalZoneDisplayName;
        } else {
          currentPageName = null;
        }

        break;
      case 'energy':
        sectionName = APP_SECTION.ENERGY.DISPLAY_NAME;
        break;
      default:
        sectionName = APP_SECTION[pageParam?.toLocaleUpperCase()]?.DISPLAY_NAME || null;
        currentPageName = null;
    }

    const newCampusName = currentCampusData?.campusDescription?.shortCampusDisplayName || null;
    const newSectionName = sectionName;
    const newPageName = currentPageName;

    const newMeta = {
      campusName: newCampusName,
      currentSectionName: newSectionName,
      currentPageName: newPageName,
    };

    updateHtmlPageTitle(newMeta);
  };

  const updateHtmlPageTitle = ({ campusName, currentSectionName, currentPageName }) => {
    setHtmlPageTitle(
      `${
        currentPageName ? `${currentPageName} | ` : ''
      }${currentSectionName ? `${currentSectionName} | ` : ''}${campusName ? `${campusName} | ` : ''}Elexity Navigator`
    );
  };

  const solarCampusCallback = (data) => {
    const campusIncluded = data.filter((campus) => campus.campusEntityKeyToken === campusParam);

    if (
      campusIncluded[0]?.energySite !== null &&
      campusIncluded[0]?.energySite !== undefined &&
      campusIncluded !== undefined
    ) {
      setSolarCampusData(campusIncluded);
      setShowSolarIcon(true);
    } else {
      setShowSolarIcon(false);
      setSolarCampusData([]);
      if (pageParam === 'solar') {
        window.location.replace(`/comfort/${campusParam}`);
      }
    }
  };

  const onBuildingChange = (buildingId) => {
    if (currentBuildingId !== buildingId) {
      setCurrentBuilding(buildingId);
    }
  };

  const onZoneChange = (zoneId) => {
    if (currentZoneId !== zoneId) {
      setCurrentZone(zoneId);
    }
  };

  const onGXChange = (gxId) => {
    if (currentGXId !== gxId) {
      setCurrentGX(gxId);
    }
  };

  const openScheduleModal = (selectModal, scheduleId) => {
    setSelectedModal(selectModal);
    setCurrentScheduleId(scheduleId);
  };

  function getResponse(response) {
    if (!response.ok) {
      if (response.status === 401) {
        authentication.logout();
        window.location.replace(authentication.logoutLink);
      }

      throw new Error('Not Accessible');
    }
    return response.json();
  }

  function checkForSolarData() {
    authenticatedComponent.getSolarCampuses(solarCampusCallback);
  }

  function processCampusJSON(json) {
    let tempCampuses = [];

    if (json) {
      tempCampuses = json;
      setCampuses(json);
    }

    saveCampuses(tempCampuses);

    //check for solar data and show/hide icon in menu
    checkForSolarData();

    //if campuses load
    if (tempCampuses) {
      if (currentCampusId === null) {
        //if assigned campus is null w/o campus param, set to first campus
        if (!campusParam) {
          setCurrentCampus(tempCampuses[0].campusEntityKey);
          authenticatedComponent.updateCampusData(
            tempCampuses[0].campusEntityKey,
            updateCampusCallback
          );
        } else {
          setCurrentCampus(campusParam);
          authenticatedComponent.updateCampusData(campusParam, updateCampusCallback);
        }
      } else {
        setCurrentCampus(currentCampusId);
        authenticatedComponent.updateCampusData(currentCampusId, updateCampusCallback);
      }

      if (showMobile) {
        if (campusParam === undefined || campusParam === '' || campusParam === null) {
          setCurrentBuilding(tempCampuses[0].buildings[0].buildingEntityKey);
        } else {
          tempCampuses.filter((campus) => {
            if (campus.campusEntityKey === campusParam) {
              setCurrentBuilding(campus.buildings[0].buildingEntityKey);
            }
          });
        }
      }
    }

    setCampusLoaded(true);
    setShowLoading(false);
  }

  function loadCampuses() {
    fetch(configuration['backend_host'] + '/ahiapi/campuses', {
      headers: authenticatedComponent.generateAuthenticatedHeader(),
    })
      .then(getResponse)
      .then(processCampusJSON)

      .catch((error) => {
        saveCampuses([]);
        console.error(error);

        setShowLoading(true);

        setTimeout(() => {
          loadCampuses();
        }, 30000);
      });
  }

  const postAuthentication = () => {
    //if stored URL, setParams
    for (var i = 0; i < sessionStorage.length; i++) {
      var value = sessionStorage.getItem(sessionStorage.key(i));

      if (sessionStorage.key(i).startsWith('state-') && value !== '/') {
        currentUrl = value;

        pageParam = value.split('/')[1] !== undefined && value.split('/')[1];
        campusParam = value.split('/')[2] !== undefined && value.split('/')[2];

        if (pageParam === 'devices' || pageParam === 'scheduler') {
          gxParam = value.split('/')[3] !== undefined && value.split('/')[3];
        }
        setCurrentCampus(campusParam);

        setHasPassthrough(true);

        if (value !== window.location.pathname) {
          window.location.replace(value);
        }
      }
    }

    sessionStorage.clear();
    loadCampuses();

    setShowLoading(false);
    processProfileData();
  };

  const processProfileData = () => {
    let userData = {
      first_name: '',
      last_name: '',
      email: '',
    };

    function getUserData() {
      fetch(configuration['backend_host'] + '/prefs/' + authentication.getUserId(), {
        headers: authenticatedComponent.generateAuthenticatedHeader(),
      })
        .then(getResponse)

        .then((data) => {
          userData.first_name = data.prefs.first_name;
          userData.last_name = data.prefs.last_name;
          userData.email = data.prefs.email;
          setUserData(userData);

          // sessionStorage.clear()
        })

        .catch((error) => {
          saveCampuses([]);
          console.error(error);

          setShowLoading(true);

          setTimeout(() => {
            getUserData();
          }, 30000);
        });
    }

    setShowLoading(false);
    getUserData();
  };

  const checkComfortInitialUrl = () => {
    // check for campus zones and redirect to comfort or energy
    if (appConfig.sections.comfort.hasZones === false) {
      return `/energy/${currentCampusId}`;
    } else {
      return `/comfort/${currentCampusId}`;
    }
  };

  function setPageData() {
    if (pageParam === '' && !hasPassthrough) {
      window.location.replace(checkComfortInitialUrl());
    } else {
      if (pageParam === 'comfort') {
        if (campusParam) {
          setCurrentGX(null);
        } else {
          window.location.replace(`/comfort/${currentCampusId}`);
        }
        //if url has building, set current building
        if (buildingParam && zoneParam) {
          setCurrentBuilding(buildingParam);
          setCurrentZone(zoneParam);
        } else {
          setCurrentBuilding(null);
          setCurrentZone(null);
        }
      } else if (pageParam === 'energy' || pageParam === 'trends' || pageParam === 'solar') {
        //if url has campus, reset building and zone
        if (campusParam) {
          authenticatedComponent.updateGXData(campusParam, updateGXCallback);

          setCurrentBuilding(null);
          setCurrentZone(null);
        } else {
          authenticatedComponent.updateGXData(currentCampusId, updateGXCallback);
          window.location.replace(`/${pageParam}/${currentCampusId}`);
        }
        // if url has gx, set current gx
        if (gxParam !== undefined) {
          setCurrentGX(gxParam);
        }
      } else if (pageParam === 'devices') {
        if (campusParam) {
          if (!gxParam) {
            window.location.replace(`/${pageParam}/${campusParam}/ev`);
          }
        } else {
          window.location.replace(`/${pageParam}/${currentCampusId}/ev`);
        }
      } else if (pageParam === 'scheduler') {
        if (campusParam) {
          authenticatedComponent.updateCampusData(campusParam, updateCampusCallback);
        } else {
          authenticatedComponent.updateCampusData(currentCampusId, updateCampusCallback);
          window.location.replace(`/${pageParam}/${currentCampusId}/schedules`);
        }
      } else if (pageParam === 'lobbyKiosk') {
        if (campusParam) {
          authenticatedComponent.fetchKioskData(gxParam, setCurrentGXData);
        } else {
          authenticatedComponent.fetchKioskData(gxParam, setCurrentGXData);
        }
      } else if (window.location.pathname !== currentUrl) {
        window.location.replace(currentUrl);
      }
    }
  }

  if (authentication.isLoggedIn()) {
    if (campusesLoaded) {
      return (
        <div className="App">
          {showLoading && <Loading message="Unable to connect, but we're trying again." />}

          <BrowserRouter>
            {pageParam.toLowerCase() !== 'lobbykiosk' && (
              <>
                <SideNav
                  campuses={campuses}
                  currentCampusId={currentCampusId}
                  activePage={activePage.toLowerCase()}
                  setActivePage={setActivePage}
                  currentWindowSize={currentWindowSize}
                  showMobile={showMobile}
                  showSolarIcon={showSolarIcon}
                />
              </>
            )}

            <Routes>
              <Route
                path="/"
                element={
                  <Comfort
                    currentCampusId={currentCampusId}
                    currentCampusData={currentCampusData}
                    updateCampusCallback={updateCampusCallback}
                    currentBuildingId={currentBuildingId}
                    currentZoneId={currentZoneId}
                    currentZoneData={currentZoneData}
                    zoneSummaryCallback={zoneSummaryCallback}
                    onBuildingChange={onBuildingChange}
                    onGXChange={onGXChange}
                    onZoneChange={onZoneChange}
                    showMobile={showMobile}
                    openScheduleModal={openScheduleModal}
                    allScheduleCallback={allScheduleCallback}
                    currentScheduleData={currentScheduleData}
                    activePage={activePage.toLowerCase()}
                    processing={processing}
                    setProcessing={setProcessing}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                  />
                }
              />
              <Route
                path="/comfort/:campusId?/:buildingId?/:zoneId?"
                element={
                  <Comfort
                    currentCampusId={currentCampusId}
                    currentCampusData={currentCampusData}
                    updateCampusCallback={updateCampusCallback}
                    currentBuildingId={currentBuildingId}
                    currentZoneId={currentZoneId}
                    currentZoneData={currentZoneData}
                    zoneSummaryCallback={zoneSummaryCallback}
                    onBuildingChange={onBuildingChange}
                    onGXChange={onGXChange}
                    onZoneChange={onZoneChange}
                    showMobile={showMobile}
                    openScheduleModal={openScheduleModal}
                    allScheduleCallback={allScheduleCallback}
                    currentScheduleData={currentScheduleData}
                    activePage={activePage.toLowerCase()}
                    processing={processing}
                    setProcessing={setProcessing}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                  />
                }
              />
              <Route
                path="/energy/:campusId?/:gxId?"
                element={
                  <Energy
                    currentCampusId={currentCampusId}
                    currentCampusData={currentCampusData}
                    currentBuildingId={currentBuildingId}
                    currentGXId={currentGXId}
                    hasSingleGX={hasSingleGX}
                    currentGXData={currentGXData}
                    onBuildingChange={onBuildingChange}
                    onGXChange={onGXChange}
                    onZoneChange={onZoneChange}
                    updateGXData={() =>
                      authenticatedComponent.updateGXData(currentCampusId, updateGXCallback)
                    }
                    showMobile={showMobile}
                    activePage={activePage.toLowerCase()}
                  />
                }
              />
              <Route
                path="/devices/:campusId?/*"
                element={
                  <Devices
                    currentCampusId={currentCampusId}
                    currentCampusData={currentCampusData}
                    currentEVData={currentEVData}
                    currentBatteryData={currentBatteryData}
                    updateEVData={() =>
                      authenticatedComponent.getEVData(currentCampusId, evCallback)
                    }
                    updateBatteryData={() =>
                      authenticatedComponent.getBatteryData(currentCampusId, batteryCallback)
                    }
                    showMobile={showMobile}
                    processing={processing}
                    setProcessing={setProcessing}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                  />
                }
              />
              <Route
                path="/trends/:campusId?/:gxId?"
                element={
                  <Trends
                    currentCampusData={currentCampusData}
                    currentCampusId={currentCampusId}
                    currentGXId={currentGXId}
                    currentGXData={currentGXData}
                    onGXChange={onGXChange}
                    updateGXData={() =>
                      authenticatedComponent.updateGXData(currentCampusId, updateGXCallback)
                    }
                    showMobile={showMobile}
                    processing={processing}
                    setProcessing={setProcessing}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                  />
                }
              />
              <Route
                path="/solar/:campusId?/:gxId?"
                element={
                  <Solar
                    currentCampusId={currentCampusId}
                    currentCampusData={currentCampusData}
                    currentGXId={currentGXId}
                    currentGXData={currentGXData}
                    onGXChange={onGXChange}
                    updateGXData={() =>
                      authenticatedComponent.updateGXData(currentCampusId, updateGXCallback)
                    }
                    showMobile={showMobile}
                    processing={processing}
                    setProcessing={setProcessing}
                    errorMessage={errorMessage}
                    solarCampusData={solarCampusData}
                    checkForSolarData={checkForSolarData}
                  />
                }
              />
              <Route
                path="/scheduler/:campusId?/*"
                element={
                  <Scheduler
                    currentCampusData={currentCampusData}
                    currentCampusId={currentCampusId}
                    openScheduleModal={openScheduleModal}
                    selectedModal={selectedModal}
                    setSelectedModal={setSelectedModal}
                    currentScheduleId={currentScheduleId}
                    setCurrentScheduleId={setCurrentScheduleId}
                    allScheduleCallback={allScheduleCallback}
                    currentScheduleData={currentScheduleData}
                    showMobile={showMobile}
                    processing={processing}
                    setProcessing={setProcessing}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                  />
                }
              />
              <Route path="/resources/:campusId?" element={<Resources showMobile={showMobile} />} />
              <Route path="/settings/:campusId?" element={<Settings showMobile={showMobile} />} />
              <Route
                path="/notifications/:campusId?"
                element={<Notifications showMobile={showMobile} />}
              />
              <Route
                path="/lobbyKiosk/:campusId?/:gxId?"
                element={
                  <LobbyKiosk
                    currentCampusId={currentCampusId}
                    currentGXId={currentGXId}
                    currentGXData={currentGXData}
                    updateGXData={() =>
                      authenticatedComponent.fetchKioskData(gxParam, setCurrentGXData)
                    }
                  />
                }
              />
            </Routes>
          </BrowserRouter>
        </div>
      );
    } else {
      return (
        <div>
          <Loading message="Loading..." />
        </div>
      );
    }
  } else {
    if (currentUrl.includes('lobbyKiosk')) {
      return (
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route
                path="/lobbyKiosk/:campusId?/:gxId?"
                element={
                  <LobbyKiosk
                    currentCampusId={currentCampusId}
                    currentGXId={currentGXId}
                    currentGXData={currentGXData}
                    updateGXData={() =>
                      authenticatedComponent.fetchKioskData(gxParam, setCurrentGXData)
                    }
                  />
                }
              />
            </Routes>
          </BrowserRouter>
        </div>
      );
    } else {
      return (
        <div>
          <Loading message="Redirecting to login..." />
        </div>
      );
    }
  }
};

const mapStateToProps = (state) => {
  return {
    campuses: state.campuses,
    currentCampusId: state.currentCampusId,
    currentBuildingId: state.currentBuildingId,
    currentZoneId: state.currentZoneId,
    currentGXId: state.currentGXId,
    currentGXData: state.currentGXData,
    currentEVData: state.currentEVData,
    currentBatteryData: state.currentBatteryData,
    currentCampusData: state.currentCampusData,
    currentZoneData: state.currentZoneData,
    currentUserData: state.currentUserData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    saveCampuses: (campusesData) => {
      dispatch(saveCampuses(campusesData));
    },
    setCurrentCampus: (campusId) => {
      dispatch(setCurrentCampus(campusId));
    },
    setCurrentBuilding: (buildingId) => {
      dispatch(setCurrentBuilding(buildingId));
    },
    setCurrentZone: (zoneId) => {
      dispatch(setCurrentZone(zoneId));
    },
    setCurrentGX: (gxId) => {
      dispatch(setCurrentGX(gxId));
    },
    setCurrentGXData: (gxData) => {
      dispatch(setCurrentGXData(gxData));
    },
    setCurrentEVData: (evData) => {
      dispatch(setCurrentEVData(evData));
    },
    setCurrentBatteryData: (batteryData) => {
      dispatch(setCurrentBatteryData(batteryData));
    },
    updateCurrentCampusData: (campusData) => {
      dispatch(updateCurrentCampusData(campusData));
    },
    setCurrentZoneData: (zoneData) => {
      dispatch(setCurrentZoneData(zoneData));
    },
    setUserData: (userData) => {
      dispatch(setUserData(userData));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
